module.exports = __webpack_public_path__ + "static/fowf-team-web-3875a24abe12832a5bae254d7665a4b3.jpg";